import { Button, PageHeader } from "@domain-group/suit-theme"
import { faHome } from "@fortawesome/pro-light-svg-icons"
import useCurrentUser from "@hooks/useCurrentUser"
import useIntegration from "@hooks/useIntegration"
import { generateUrls } from '@hooks/useTemplatePage'
import useTemplatePages from "@hooks/useTemplatePages"

interface HeaderProps {
  activeTabBarItemKey: 'linked_templates' | 'field_mapping',
}
const Header = (props: HeaderProps) => {
  const { activeTabBarItemKey } = props
  const { isBrandUser } = useCurrentUser()
  const { integrated } = useIntegration()
  const { canvaTemplatePagesIndexUrl, canvaTemplatesFieldMappingUrl } = generateUrls()

  const {
    callbacks: { syncBrandTemplates },
    loading,
  } = useTemplatePages({})

  return (
    <PageHeader
      actionContent={( isBrandUser &&
        <Button
          buttonStyle="primaryCreate"
          disabled={!integrated}
          loading={loading}
          loadingBubbleColor="white"
          size="medium"
          onClick={() => { syncBrandTemplates() }}
        >
          Link New Templates
        </Button>
      )}
      activeTabBarItemKey={activeTabBarItemKey}
      boxProps={{ height: [112, 105], justifyContent: 'flex-start' }}
      tabBarItems={[
        {
          href: canvaTemplatePagesIndexUrl,
          icon: faHome,
          key: 'linked_templates',
          title: 'Linked Templates',
        },
        {
          href: canvaTemplatesFieldMappingUrl,
          icon: faHome,
          key: 'field_mapping',
          title: 'Field Mapping',
        },
        // {
        //   href: canvaTemplatesUrl,
        //   icon: faHistory,
        //   key: 'true',
        //   title: 'Activity',
        // },
      ]}
      title="Canva Templates"
    />
  )
}

export default Header